// Environment variable configuration and validation for Vite
export const config = {
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL,
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
    serviceRole: import.meta.env.VITE_SUPABASE_SERVICE_ROLE,
  },
  storage: {
    videosBucket: import.meta.env.VITE_SUPABASE_VIDEOS_BUCKET || 'videos',
    outputsBucket: import.meta.env.VITE_SUPABASE_OUTPUTS_BUCKET || 'outputs',
  },
  api: {
    baseUrl: import.meta.env.VITE_API_URL || '',
  }
}

// Validate required environment variables
export function validateConfig() {
  const required = [
    'VITE_SUPABASE_URL',
    'VITE_SUPABASE_ANON_KEY'
  ]
  
  const missing = required.filter(key => !import.meta.env[key])
  
  if (missing.length > 0) {
    console.error('❌ Missing required environment variables:', missing)
    console.error('Please check your .env file')
    return false
  }
  
  console.log('✅ All required environment variables are set')
  return true
}

// Get storage bucket configuration
export function getStorageConfig() {
  return {
    videos: config.storage.videosBucket,
    outputs: config.storage.outputsBucket,
  }
}

// Check if running in development
export const isDev = import.meta.env.DEV

// Check if running in production
export const isProd = import.meta.env.PROD
